"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = exports.subscribeWindowSize = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const subscribers = new Map();
const resizeListener = (0, utils_1.debounce)(() => subscribers.forEach((callback) => callback(getWindowSizes())), 300);
function setupEventListener() {
    window.addEventListener('resize', resizeListener);
}
function disableEventListener() {
    window.removeEventListener('resize', resizeListener);
}
function subscribeWindowSize(callback) {
    if (Object.values(subscribers).length === 0) {
        setupEventListener();
    }
    let id;
    do {
        id = (0, utils_1.cuid)();
    } while (subscribers.has(id));
    subscribers.set(id, callback);
    return function unsubscribe() {
        subscribers.delete(id);
        if (Object.values(subscribers).length === 0) {
            disableEventListener();
        }
    };
}
exports.subscribeWindowSize = subscribeWindowSize;
function getWindowSizes() {
    return typeof window === 'undefined'
        ? { width: 1920, height: 1080 }
        : {
            width: window.visualViewport.width || window.innerWidth,
            height: window.visualViewport.height || window.innerHeight,
        };
}
function pickWindowSizes(dimensions, sizes = getWindowSizes()) {
    const result = {};
    if (dimensions.width) {
        result.width = sizes.width;
    }
    if (dimensions.height) {
        result.height = sizes.height;
    }
    return result;
}
function useWindowSize(dimensionsPick = { width: true }) {
    const dimensionsRef = (0, react_1.useRef)(dimensionsPick);
    const dimensions = dimensionsRef.current;
    const [size, setSize] = (0, react_1.useState)(pickWindowSizes(dimensions));
    (0, react_1.useEffect)(() => {
        if (Object.keys(dimensions).length === 0) {
            return;
        }
        setSize(pickWindowSizes(dimensions));
        return subscribeWindowSize(() => {
            const newSize = pickWindowSizes(dimensions);
            setSize((currentSize) => Object.keys(currentSize).some((key) => newSize[key] !== currentSize[key])
                ? newSize
                : currentSize);
        });
    }, [dimensions]);
    return size;
}
exports.useWindowSize = useWindowSize;
